'use client';

import { useMemo } from 'react';

import {
  type ClientCapabilities,
  clientIdentifierToCapabilities,
  getClientIdentifierFromUserAgentString,
  ClientFeature,
} from '../helpers/client-capabilities-universal-helpers';

export { ClientFeature };

export type ReadyAwareClientCapabilities = ClientCapabilities & {
  ready: boolean;
};

type UseClientIdentifierHook = () => ReadyAwareClientCapabilities;

/**
 * Returns the client identifier based on the current user agent string. The property `ready` is set to true, once the user agent is available & was parsed.
 */
export const useClientCapabilities: UseClientIdentifierHook = () => {
  const agent =
    typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

  const capabilities = useMemo(() => {
    return clientIdentifierToCapabilities(
      getClientIdentifierFromUserAgentString(agent ?? ''),
    );
  }, [agent]);

  return {
    ...capabilities,
    ready: typeof agent !== 'undefined',
  };
};
